// extracted by mini-css-extract-plugin
module.exports = {"full_wrapper":"style_full_wrapper__11_WE","title":"style_title__32_BH","subTitle":"style_subTitle__1Hfdh"};